import React from 'react';
import {Box, useTheme} from "@mui/material";
import Footer from "../../components/footer";
import {CustomTheme} from "../../config/theme/theme";

interface LoginLayoutProps {
  children: React.ReactNode;
}

export const LoginLayout = (props: LoginLayoutProps) => {
  const theme: CustomTheme = useTheme();

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" height="100vh" width="100%">
        <Box bgcolor={theme.palette.background.dashboard} display="flex" flexDirection="column" justifyContent="center"
             alignItems="center" p={3} width="100%" maxWidth="1920px" flexGrow={1}>
          {props.children}
        </Box>
        <Box flexGrow={0} width="100%">
          <Footer/>
        </Box>
      </Box>
    </>
  );
};
